<template>
    <div>
        <div class="bg">
            <div class="inner">
                <div class="row">

                    <div class="col-lg-12">

                        <div class="control-group">
                            <div class="controls form-inline">

                                <label><input type="radio" name="pos" v-model="pos" value="1" @click="doFilter()"> {{ t('Position') }} 1</label>
                                <label><input type="radio" name="pos" v-model="pos" value="2" @click="doFilter()"> {{ t('Position') }} 2</label>
                                <label><input type="radio" name="pos" v-model="pos" value="3" @click="doFilter()"> {{ t('Position') }} 3</label>
                                <label><input type="radio" name="pos" v-model="pos" value="4" @click="doFilter()"> {{ t('Position') }} 4</label>
                                <label><input type="radio" name="pos" v-model="pos" value="5" @click="doFilter()"> {{ t('Position') }} 5</label>
                                <label><input type="radio" name="pos" v-model="pos" value="6" @click="doFilter()"> {{ t('Position') }} >5</label>

                                <label><input type="checkbox" v-model="onlyCompetitors" @click="doFilter()"> {{ t('Only with competitors') }}</label>

                                <div id="datatable-length-box" class="pull-right"></div>
                                <div id="datatable-search-box" class="pull-right"></div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <br />

        <div id="table-wrapper"></div>

    </div>
</template>

<script>
    window.jQuery = $;
    require('datatables.net-bs');
    require('datatables.net-fixedcolumns');
    require('bootstrap');
    require('bootstrap-multiselect/dist/js/bootstrap-multiselect');

    import Vue from 'vue';
    import ProductDetails from './ProductDetails.vue';
    import {product} from '../services';

    let ProductDetailsLoader = Vue.extend(ProductDetails);

    export default {
        name: 'DataGrid',
        data() {
            return {
                columns: [],
                dtLength: null,
                filter: {},
                group: 1,
                pos: 1,
                onlyCompetitors: false,
                dt: {
                    forceID: null,
                    instance: null,
                    options: {
                        language: {
                            "processing": this.$translate.text("Processing")+'...',
                            "search": this.$translate.text("Search")+':',
                            "lengthMenu": this.$translate.text("Show _MENU_ position"),
                            "info": this.$translate.text("Position _START_ - _END_ of _MAX_"),
                            "infoEmpty": this.$translate.text("Position 0 of 0 available"),
                            "infoFiltered": "",
                            "infoPostFix": "",
                            "loadingRecords": this.$translate.text("Loading")+'...',
                            "zeroRecords": this.$translate.text("Records not found"),
                            "emptyTable": this.$translate.text('Not found'),
                            "paginate": {
                                "first": this.$translate.text("First"),
                                "previous": this.$translate.text("Previous"),
                                "next": this.$translate.text("Next"),
                                "last": this.$translate.text("Last")
                            },
                            "aria": {
                                "sortAscending": ': ' + this.$translate.text("active to asc sort column"),
                                "sortDescending": ': '+ this.$translate.text("active to desc sort column")
                            }
                        },
                        scrollY: '55vh',
                        scrollX: true,
//                        scrollCollapse: true,
//                        fixedColumns: {
//                            leftColumns: 1
//                        },
                        autoWidth: true,
                        sort: true,
                        searching: true,
                        paging: true,
                        lengthMenu: [[10, 50, 100, 250, 500], [10, 50, 100, 250, 500]],
                        processing: true,
                        serverSide: true,
                        columnDefs: [
                            { "orderable": false, "targets": 'no-sort' }
                        ],
                    }
                },
                // rule: this.getDefaultRules(),
                // ruleCleaned: true,
                shops: [],
                searchValue: null,
            }
        },
        mounted() {
            this.initPage();
        },
        methods: {
            initPage(params) {
                this.$http.get('price-position/init', {params: params || {}}).then((response) => {
                    this.columns = response.body.columns;
                    this.initDT();
                })
            },
            doFilter() {
                const v = this;
                setTimeout(function () {
                    v.initDT();
                }, 10);
            },
            initDT() {
//                console.trace();
                const v = this;
                let tableHeaders = '';

                for (let i in this.columns) {
                    if (this.columns.hasOwnProperty(i)) {
                        tableHeaders += '<th>' + this.columns[i].name + '</th>';
                    }
                }

                this.dt.options.columns = this.columns;
                this.dt.options.ajax = function (data, callback) {
                    // some issue with 'length' prop
                    data.page_length = data.length;
                    delete data.length;

                    delete data.columns;

                    data.group = v.group;
                    data.position = v.pos;
                    data.onlyCompetitors = v.onlyCompetitors ? 1 : 0;
                    // data.conditions = [];
                    // data.filter = {};

                    // for (let key in v.filter) {
                    //     if (v.filter[key] > 0) {
                    //         data.filter[key] = v.filter[key];
                    //     }
                    // }

                    // if (v.dt.forceID) {
                    //     data.forceID = v.dt.forceID;
                    // }
                    // if (v.own) {
                    //     data.own = true;
                    // }

                    v.$http.get('price-position/dt', {params: data}).then((response) => {
                        callback(response.body);
                        v.searchValue = response.body.searchValue;
                        // v.category = response.body.category;
                    })
                };

                if (this.dt.instance !== null) {
                    this.dt.instance.destroy();
                }

                $('#table-wrapper')
                    .empty()
                    .append('<table id="datagrid" class="table" cellspacing="0" style="width:100%;">' +
                        '<thead><tr>' + tableHeaders + '</tr></thead></table>');

                let datagrid = $('#datagrid');

                this.dt.instance = datagrid.DataTable(this.dt.options);

                this.$store.dispatch('setDT', this.dt);

                // open product (row) details
                datagrid.find('tbody').on('click', 'tr td .row-details', (e) => {
                    e.preventDefault();

                    let a = $(e.target);

                    let id = a.data('id');
                    let tr = a.closest('tr');
                    let row = v.dt.instance.row(tr);

                    if (row.child.isShown()) 
                    {
                        row.child.hide();
                        
                        $(a).removeClass('glyphicon-chevron-up');
                        $(a).addClass('glyphicon-chevron-down');
                    }
                    else 
                    {
                        $(a).removeClass('glyphicon-chevron-down');
                        $(a).addClass('glyphicon-chevron-up');

                        let container=row.child(() => {
                            return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">'+this.$translate.text('Processing')+'...</div></div>';
                        });
                        container.show();
                        v.$http.get('reports/details', {params: {id: id}}).then((response) => {

                            new ProductDetailsLoader({data: response.body}).$mount($(row.child()[0]).find('div')[0])
                        })
                    }
                });

                let dtSearch = $('#datagrid_filter'), newDtSearch = $('#datatable-search-box');
                let dtSearchInput = dtSearch.find('input[type="search"]');

                newDtSearch.empty();

                if (!newDtSearch.has('input').length)
                {
                    dtSearchInput.addClass('form-control');
                    dtSearchInput.removeClass('input-sm');

                    dtSearchInput.attr('placeholder', this.$translate.text('Search name or erp code'));

                    newDtSearch.append(dtSearchInput);
                }

                dtSearch.remove();

                let dtLength = $('#datagrid_length'), dtBox = $('#datatable-length-box');
                let dtLengthInput = dtLength.find('select');

                if (v.dtLength !== null) {
                    dtLengthInput.val(v.dtLength);
                    dtLengthInput.trigger('change');
                }

                dtBox.html( dtLengthInput.removeClass('input-sm') );
                dtLength.remove();

                $('select[name="datagrid_length"]').change(function(){
                    v.dtLength = $(this).val();
                });

                // // change repricing rule for product
                // datagrid.find('tbody').on('click', 'tr td .rule-change', (e) => {
                //     e.preventDefault()
                //
                //     let a = $(e.target)
                //     let select = a.parent().find('.rule-select')
                //
                //     a.hide();
                //     select.show().focus();
                //
                //     select.off('change').on('change', () => {
                //         product.changeRule(v, {repricing_rule_id: select.val()}, select.data('id'), response => {
                //             a.html(select.find('option:selected').text()).show()
                //             select.hide();
                //             if (response.body) {
                //                 $('#proposed-price-' + response.body.product_id).html(response.body.proposed_price)
                //             }
                //         })
                //     })
                //     select.off('blur').on('blur', () => {
                //         a.show()
                //         select.hide()
                //     })
                // });

                // close product from notifications
                datagrid.find('tbody').on('click', 'tr td .close-preview', (e) => {
                    this.$store.dispatch('closeProductFromNotification')
                });
            }
        }
    }
</script>

<style>
    @import "./../../node_modules/datatables.net-bs/css/dataTables.bootstrap.css";
    @import "./../../node_modules/bootstrap-multiselect/dist/css/bootstrap-multiselect.css";

    /*table {
        background: #fff;
    }
    table.dataTable {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }
    .DTFC_LeftBodyLiner {
        top: -2px !important;
    }*/
    /*.dataTable tbody tr {
        height: 35px; !* or whatever height you need to make them all consistent *!
    }
    .dataTable th {
        background: #fff;
    }*/

    .amount {
        width: 100px;
        display: inline-block;
    }

    .w100 {
        width: 280px;
    }

    .w75 {
        width: 205px;
    }

    .w50 {
        width: 130px;
    }

    input[type="number"], input[type="amount"] {
        width: 70px;
    }

    .input-block {
        display: inline-block;
    }

    .col-fixed, .price-rules {
        min-width: 720px;
    }

    .arrows {
        line-height: 10px;
    }

    .arrow {
        display: inline-block !important;
        width: 9px;
        height: 6px;
    }

    .arrow-up {
        background: url('../assets/img/up.png') no-repeat 0 0;
    }

    .arrow-up:hover {
        background-position: -9px;
    }

    .arrow-down {
        background: url('../assets/img/down.png') no-repeat 0 0;
    }

    .arrow-down:hover {
        background-position: -9px;
    }

    .price-rules .text {
        line-height: 20px;
    }

    .loading-fragment{
        position: relative;
        height:100px;
    }
    .control-group label {
        margin-right: 40px;
    }
</style>



// WEBPACK FOOTER //
// PricePosition.vue?d0a121a2